/* Built In Imports */
/* External Imports */
import { Box, Center, Flex, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Styles */
import MiracleSt from '@moms/styleData/MiracleSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const MomHeading = ({ region, lang, sectionContent }) => {
  const titleData = sectionContent?.[0]?.title?.[0];
  // Safely extract the titleText and titleSubtext
  const titleText = titleData?.titleText;
  const titleSubtext = titleData?.titleSubtext;
  const additionalText = titleData?.additionalTextLine;

  return (
    <Box
      width={'100%'}
      display={{ base: 'block', md: 'flex' }}
      gap=".8rem"
      px="1rem"
    >
      <Box {...MiracleSt?.[lang]?.title}>
        {titleText}
        <Text as="span" {...MiracleSt?.[lang]?.titleSubtext}>
          {' '}
          {titleSubtext}
        </Text>
        <Text as="span" color={'#FFFFFF'} {...MiracleSt?.[lang]?.additional}>
          {' '}
          {additionalText}
        </Text>
      </Box>
    </Box>
  );
};

const FlexItems = ({ region, lang, sectionContent }) => {
  const benefits = sectionContent[0]?.benefits || [];
  const rearrangedBenefits = [
    benefits[0],
    benefits[3],
    benefits[1],
    benefits[4],
    benefits[2],
    benefits[5],
  ];
  return (
    <Flex
      wrap="wrap"
      gap={{ base: '2rem', md: '20px', xl: '3rem' }}
      columnGap={{ xl: '5rem' }}
      ml={{ base: 'auto', md: '2rem', xl: '1rem' }}
      mr={{ base: 'auto', md: '0' }}
      justifyContent={{ base: 'center', md: 'unset' }}
      alignItems={'center'}
    >
      {rearrangedBenefits.map((item, index) => (
        <Box
          key={index}
          w={{ base: '100%', md: '288px' }}
          maxW={{ base: '149px', md: '100%' }}
          display={'flex'}
          mt={{ base: '2rem', md: '0' }}
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          alignItems={{ base: 'center' }}
          justifyContent={{ base: 'center', md: 'flex-start' }}
          h={{ lg: '80px' }}
          flexDir={{ base: 'column', md: 'row' }}
          gap={{ base: '1rem', md: '1.5rem' }}
        >
          {/* Icon box */}
          <Center width="80px" height="80px" flex={1} maxW="80px">
            <Image
              src={item.image?.url}
              alt={item.image?.alt || 'Benefit image'}
            />
          </Center>
          <Text
            maxW={{ base: 150, md: 190 }}
            flex={1}
            px={{ base: '.5rem', md: '0' }}
            {...MiracleSt?.[lang]?.item}
          >
            {item.text}
          </Text>
        </Box>
      ))}
    </Flex>
  );
};

const SeeMircale = ({ region, lang, sectionContent }) => {
  const imageUrl = sectionContent[1]?.image?.url;
  return (
    <Box>
      <Flex maxW={'1300px'} width={'100%'} mx="auto">
        <Box
          bgColor={'#010102'}
          bgImage={{ md: `url(${imageUrl})` }}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="cover"
          width={{ base: '0%', md: '50%', xl: '40%' }}
          // py={{ base: '6rem', md: '11.875rem' }}
          // px={{ base: '1rem', md: '0' }}
        />

        {/* container flex for heading and text */}

        <Flex
          maxW={'746px'}
          w={{ base: '100%', md: '60%' }}
          flexDirection={'column'}
          my={{ base: '5rem', md: '8rem', lg: '12rem' }}
          justifySelf={{ md: 'end' }}
          ml={{ xl: '2rem', '2xl': '0' }}
          gap={{ md: '3.5rem' }}
        >
          {/* main heading  */}

          <MomHeading
            region={region}
            lang={lang}
            sectionContent={sectionContent}
          />
          <FlexItems
            region={region}
            lang={lang}
            sectionContent={sectionContent}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default SeeMircale;
